import React from 'react';
import { Button } from '../ui/button';
import { Card } from '../ui/card';
import { Input } from '../ui/input';
import {
  Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerDescription,
} from '../ui/drawer';
import { Search, Package, X } from 'lucide-react';

export default function PesquisaDrawer({
  open,
  onOpenChange,
  searchTerm,
  onSearchChange,
  filteredOfs,
  user,
  onSelectOf,
}) {
  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent className="max-h-[85vh]">
        <DrawerHeader className="border-b border-stone-100 pb-4">
          <div className="flex items-center justify-between">
            <div>
              <DrawerTitle className="text-xl font-heading text-navy">Pesquisar OF</DrawerTitle>
              <DrawerDescription className="text-stone-500">
                Digite o número da OF para pesquisar
              </DrawerDescription>
            </div>
            <Button
              variant="ghost"
              size="icon"
              onClick={() => onOpenChange(false)}
              className="rounded-full"
            >
              <X className="h-5 w-5" />
            </Button>
          </div>
          <div className="relative mt-4">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-stone-400" />
            <Input
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Digite pelo menos 2 caracteres..."
              className="h-12 pl-12 rounded-full border-2 border-stone-200 focus:border-navy"
              data-testid="search-input"
              autoFocus
            />
          </div>
        </DrawerHeader>

        <div className="p-4 overflow-y-auto max-h-[50vh]">
          {searchTerm.length < 2 ? (
            <div className="text-center py-8">
              <Search className="h-12 w-12 mx-auto text-stone-300 mb-3" />
              <p className="text-stone-500">Digite o número da OF para pesquisar</p>
              <p className="text-xs text-stone-400 mt-1">Mínimo 2 caracteres</p>
            </div>
          ) : filteredOfs.length === 0 ? (
            <div className="text-center py-8">
              <Package className="h-12 w-12 mx-auto text-stone-300 mb-3" />
              <p className="text-stone-500">Nenhuma OF encontrada</p>
              <p className="text-xs text-stone-400 mt-1">Apenas OFs com lotes aprovados e atribuídas a si</p>
            </div>
          ) : (
            <div className="space-y-2">
              {filteredOfs.map((of) => {
                const operacoesAtribuidas = (of.operacoes || [])
                  .filter(op => op.operadores_atribuidos?.includes(user?.id)).length;

                return (
                  <Card
                    key={of.id}
                    className="p-4 bg-warm-subtle rounded-2xl border-0 cursor-pointer hover:bg-white hover:shadow-soft transition-all"
                    onClick={() => onSelectOf(of)}
                    data-testid={`search-result-${of.numero_of}`}
                  >
                    <div className="flex items-center justify-between">
                      <div>
                        <div className="flex items-center gap-2 mb-1">
                          <p className="font-mono font-bold text-navy">{of.numero_of}</p>
                          {operacoesAtribuidas > 0 && (
                            <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-primary/10 text-primary">
                              {operacoesAtribuidas} atribuídas
                            </span>
                          )}
                        </div>
                        <p className="text-sm text-stone-600">{of.cliente}</p>
                        <p className="text-xs text-stone-400">{of.artigo}</p>
                      </div>
                      <div className="text-right">
                        <p className="text-lg font-bold text-navy">{of.operacoes?.length || 0}</p>
                        <p className="text-xs text-stone-500">operações</p>
                      </div>
                    </div>
                  </Card>
                );
              })}
            </div>
          )}
        </div>
      </DrawerContent>
    </Drawer>
  );
}
